(function() {
    'use strict';

    function resourcePartnerConnectionSummariesController($scope, $routeParams, resourcePartnerConnectionsDataService, notifyService) {
        var vm = this;
        vm.entityId = '';
        vm.results = [];
        vm.currentResourcePartnerConnectionIndex = null;

        $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            vm.entityId = toParams.entityId;
        });

        function resetEditor() {
            vm.currentResourcePartnerConnection = {};
            vm.currentResourcePartnerConnectionIndex = null;
        }

        vm.isActiveRow = function (index) {
            return index === vm.currentResourcePartnerConnectionIndex;
        }

        vm.editResourcePartnerConnection = function (index) {
            vm.currentResourcePartnerConnectionIndex = index;
            vm.currentResourcePartnerConnection = vm.results[index];
            vm.originalStatus = vm.currentResourcePartnerConnection.Status;
        }

        vm.cancelEditResourcePartnerConnection = function () {
            vm.currentResourcePartnerConnection.Status = vm.originalStatus;
            resetEditor();
        }

        vm.saveResourcePartnerConnection = function () {
            resourcePartnerConnectionsDataService.update(vm.entityId,
                vm.currentResourcePartnerConnection.PartnerId,
                { Status: vm.currentResourcePartnerConnection.Status, ActivityDate: new Date() }).then(function () {
                    notifyService.notify('Your changes were saved successfully');
                    resetEditor();
                });
        }
    }

    resourcePartnerConnectionSummariesController.$inject = ['$scope', '$routeParams', 'resourcePartnerConnectionsDataService', 'notifyService'];

    angular.module('ecap.crm').controller('resourcePartnerConnectionSummariesController', resourcePartnerConnectionSummariesController);
})();
